/**
 * 本地資料庫
 * 設定
 * @author J
 * @since 2024-04-30 07:34:25
 */

import {defineStore} from "pinia"
import {PiniaEnum} from "@/v2/enumerate/pinia";
import PiniaPersistConfiguration from "@/v2/configuration/pinia";
import {SettingFormTableOpenEnum, SettingLoginEnum, SettingThemeEnum} from "@/v2/enumerate/setting";

export const SettingStore = defineStore({
    id: PiniaEnum.SETTING,
    state: () => ({
        menu: {
            collapsed: {
                enable: false
            },
            overlay: {
                enable: false
            },
            caption: {
                my: "",
                soul: "",
                daily: ""
            }
        },
        theme: SettingThemeEnum.LIGHT,
        region: "zhTW",
        authorized: SettingLoginEnum.PASSWD,
        form: {
            edit: {
                open: SettingFormTableOpenEnum.SELF
            }
        }
    }),
    getters: {
        isMenuCollapsed: state => {
            return state.menu.collapsed.enable
        },
        isMenuOverlay: state => {
            return state.menu.overlay.enable
        },
        getMenuCaption: state => {
            return state.menu.caption
        },
        isDarkTheme: state => {
            return state.theme === SettingThemeEnum.DARK
        },
        getRegion: state => {
            return state.region
        },
        getAuthorized: state => {
            return state.authorized
        },
        getFormTableOpen: state => {
            return state.form.edit.open
        }
    },
    actions: {
        setMenuCollapsed(enable) {
            this.menu.collapsed.enable = enable;
        },
        setMenuOverlay(enable) {
            this.menu.overlay.enable = enable;
        },
        setMenuCaption(caption) {
            this.menu.caption = caption;
        },
        setTheme(theme) {
            this.theme = theme;
        },
        setRegion(region) {
            this.region = region;
        },
        setAuthorized(authorized) {
            this.authorized = authorized;
        },
        setFormTableOpen(open) {
            this.form.edit.open = open;
        }
    },
    persist: PiniaPersistConfiguration(PiniaEnum.SETTING)
})